import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import LogoSeparator from '../../shared/logo-separator';
import ContributorResultsContext from './context';

const ATTRS = {
  all: {
    loading: 'loadingAllWires',
    wires: 'allWires',
  },
  latest: {
    loading: 'loadingLatestWires',
    wires: 'latestWires',
  },
  mentions: {
    loading: 'loadingMentionedWires',
    wires: 'mentionedWires',
  },
};

export default function Separator({ type }) {
  const { state } = React.useContext(ContributorResultsContext);

  if (!_.get(state, `${ATTRS[type].wires}.length`)) {
    return null;
  }

  return (
    <LogoSeparator animate={_.get(state, ATTRS[type].loading) === 'more'} />
  );
}

Separator.propTypes = {
  type: PropTypes.oneOf(['all', 'latest', 'mentions']).isRequired,
};
